import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 22a10 10 0 110-20 10 10 0 010 20zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z"/>
  </SvgIcon>
);